import React from "react";
import {
    Datagrid,
    List,
    TextField,
    Create,
    SimpleForm,
    TextInput,
    ChipField,
    ReferenceArrayField,
    SingleFieldList,
    SelectArrayInput,
    ReferenceArrayInput

} from "react-admin";
import Edit from "./components/Edit";


export const MindfulnessList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="name"/>

                <ReferenceArrayField label="Category" reference="Category" source="categoryIds">
                    <SingleFieldList>
                        <ChipField source="id"/>
                    </SingleFieldList>
                </ReferenceArrayField>

            </Datagrid>
        </List>
    );
};
const MindfulnessFormInput = ({
    ...props
}) => {

    return (
        <SimpleForm {...props} warnWhenUnsavedChanges>
            <TextInput source="name"/>


            <ReferenceArrayInput label="Category" reference="Category" source="categoryIds">
                <SelectArrayInput optionText="name"/>
            </ReferenceArrayInput>


        </SimpleForm>
    );
};
export const MindfulnessEdit = (props) => (
    <Edit {...props}>
        <MindfulnessFormInput/>
    </Edit>
);

export const MindfulnessCreate = (props) => { // Read the dayId from the location which is injected by React Router and passed to our component by react-admin automatically
    return (
        <Create {...props}>
            <MindfulnessFormInput/>
        </Create>
    );
};
